import { Link } from "react-router";

/**
 * Numbered editorial service row for the home page — full-width image with
 * an oversized title, replacing the old card grid. Static per DESIGN.md
 * Motion: none.
 */
interface ServiceRowProps {
  service: {
    title: string;
    description: string;
    image: { src: string; location: string; alt?: string };
    href: string;
  };
  index: number;
}

export function ServiceRow({ service, index }: ServiceRowProps) {
  const number = String(index + 1).padStart(2, "0");

  return (
    <Link
      to={service.href}
      className="group block"
      aria-label={`${service.title}: ${service.description}`}
    >
      <div className="grid md:grid-cols-2 gap-5 md:gap-12 items-center">
        {/* Image first on mobile so each title sits under its photo */}
        <div
          className={`order-2 ${index % 2 === 1 ? "md:order-2" : "md:order-1"}`}
        >
          <p className="text-sm font-medium text-orange-600 mb-3">{number}</p>
          <h3 className="text-3xl md:text-5xl font-bold tracking-tight text-gray-900">
            {service.title}
          </h3>
          <p className="text-gray-600 text-lg mt-3 md:mt-4 font-medium max-w-md">
            {service.description}
          </p>
        </div>
        <div
          className={`aspect-[3/2] relative rounded-md overflow-hidden order-1 ${
            index % 2 === 1 ? "md:order-1" : "md:order-2"
          }`}
        >
          <img
            src={service.image.src}
            alt={service.image.alt || service.title}
            loading="lazy"
            className="absolute inset-0 h-full w-full object-cover"
          />
          <p className="absolute bottom-3 right-3 text-white text-xs font-medium [text-shadow:0_1px_3px_rgba(0,0,0,0.85)]">
            {service.image.location}
          </p>
        </div>
      </div>
    </Link>
  );
}
